import linked from '../resources/linked.webp'
import Github from '../resources/Github.webp'

const ContactMe = () => {
  return (
    <div id="contactMe">
      <h1 className="contact">
        <section>04.</section>Get in Touch!
      </h1>
      <div className="contact-container">
        <div className="contact-content">
          <h2 className="contact-title">Let's Create Something Amazing Together</h2>
          <div className="contactInfo">
            If anything on my portfolio has piqued your interest, or if you have an exciting project in mind, 
            I'd love to hear from you! Whether it's discussing potential opportunities, collaborating on 
            innovative solutions, or just having a conversation about technology, feel free to reach out.
          </div>
          <div className="contactInfoLinks">
            <a className="email" href="mailto:nickamenda@gmail.com" target="_blank" rel="noreferrer">
              <button>Get In Touch</button>
            </a>
            <div className="social-links">
              <a href="https://www.linkedin.com/in/nicholasamenda/" target="_blank" rel="noreferrer" className="linkedin">
                <img src={linked} alt="LinkedIn logo" title="LinkedIn"></img>
              </a>
              <a href="https://github.com/nickamenda/" target="_blank" rel="noreferrer" className="github">
                <img alt="GitHub logo" src={Github} title="GitHub"></img>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactMe;
